export default __webpack_public_path__ + "static/media/02661183-0d8d-4542-b0a8-b09e65ae50b8.2d317836.JPG";